import { Flex, Button } from "@chakra-ui/react";

const StepNavigation = ({
                          step,
                          totalSteps,
                          isLoading,
                          onPrev,
                          onNext,
                          onSubmit,
                          onVerify,
                        }) => {
  return (
      <Flex gap={{ base: "5%", md: "2%" }}>
        {step > 0 && step < totalSteps && (
            <Button
                width={{ base: "25%", md: "18%" }}
                onClick={onPrev}
                variant="outline"
                size={{ base: "lg", md: "xl" }}
            >
              Back
            </Button>
        )}

        {step < totalSteps - 2 && (
            <Button
                width={{ base: step > 0 ? "70%" : "100%", md: step > 0 ? "80%" : "100%" }}
                onClick={onNext}
                bg="gray.700"
                size={{ base: "lg", md: "xl" }}
            >
              Next
            </Button>
        )}

        {step === totalSteps - 2 && (
            <Button
                width={{ base: "70%", md: "80%" }}
                onClick={onSubmit}
                bg="gray.700"
                size={{ base: "lg", md: "xl" }}
                loading={isLoading}
                loadingText="Submitting..."
            >
              Submit
            </Button>
        )}

        {step === totalSteps - 1 && (
            <Button
                width={{ base: "70%", md: "80%" }}
                size={{ base: "lg", md: "xl" }}
                bg="gray.700"
                onClick={onVerify}
                loading={isLoading}
                loadingText="Verifying..."
            >
              Verify
            </Button>
        )}
      </Flex>
  );
};

export default StepNavigation;